import React, { useState, useEffect } from "react";
import TopbarComponentWithoutPage from "../components/Topbarwithoutpage";
import "../style.css";
import nextbtn_new from "../image/nextbtn_new.png";
import icon_card from "../image/icon_card@2x.png";
import icon_card_blue from "../image/icon_cardblue@2x.png";
import icon_won from "../image/icon_won@2x.png";
import icon_won_blue from "../image/icon_wonblue@2x.png";
import GuidelineComponent3 from "../components/Guideline3";
import $ from "jquery";
import askalsal from "../image/z1d4.png";
import new_blue2 from "../image/new_blue.png";
import kakaoaa from "../image/kakaoaa.png";
import card123 from "../image/card123.png";
import card1234 from "../image/card1234.png";
import pay123 from "../image/pay123.png";
import pay1234 from "../image/pay1234.png";
import BrowserHeader from "../components/BrowserHeader";
import {
  BrowserRouter,
  Route,
  Switch as Routes,
  Link,
  NavLink,
  useParams,
  useHistory,
} from "react-router-dom";
import {
  BrowserView,
  MobileView,
  isBrowser,
  IsMobile,
  TabletView,
} from "react-device-detect";
import ReactPixel from "react-facebook-pixel";

const PIXEL_ID = "266266868791844";
ReactPixel.init(PIXEL_ID);

function Personalpayment() {
  const history = useHistory();
  useEffect(() => {
    btnCheck();
  });
  const [nextbtn, setNextbtn] = useState(nextbtn_new);
  const [cardCount, setCardCount] = useState(0);
  const [cashCount, setCashCount] = useState(0);
  const [cardImg, setCardImg] = useState([icon_card]);
  const [cashImg, setCashImg] = useState([icon_won]);
  const [cardImg1, setCardImg1] = useState([card123]);
  const [cashImg1, setCashImg1] = useState([pay123]);
  const [eventcss, setEventcss] = useState("disabled-link");
  const [paymethod, setPaymethod] = useState([""]);
  const [paymethod2, setPaymethod2] = useState([""]);
  const cardCheck = () => {
    if (cardCount === 0) {
      setCardCount(1);
      setPaymethod("card");
      setPaymethod2("F");
      if (cashCount === 1) {
        cashCheck();
      }
      $("#card_text").css("color", "rgb(74, 100, 245)");
      $("#card").css("border", "solid 1px #4f63ec");
      $("#card").css("background-color", "#edefff");
      setCardImg([icon_card_blue]);
    } else {
      setCardCount(0);
      $("#card_text").css("color", "rgb(81, 81, 81)");
      $("#card").css("border", "");
      $("#card").css("background-color", "#ffffff");
      setCardImg([icon_card]);
    }
  };

  const cardCheck1 = () => {
    if (cardCount === 0) {
      setCardCount(1);
      setPaymethod("card");
      setPaymethod2("F");
      if (cashCount === 1) {
        cashCheck1();
      }

      setCardImg1([card1234]);
    } else {
      setCardCount(0);
      setCardImg1([card123]);
    }
  };
  const cashCheck1 = () => {
    if (cashCount === 0) {
      setCashCount(1);
      setPaymethod("vbank");
      setPaymethod2("T");
      if (cardCount === 1) {
        cardCheck1();
      }
      setCashImg1([pay1234]);
    } else {
      setCashCount(0);
      setCashImg1([pay123]);
    }
  };
  const btnCheck = () => {
    if (cardCount === 1 || cashCount === 1) {
      $("#next_button").css("background-color", "#4a64f5");
      setEventcss("");
      $("#dam").css("color", "#ffffff");
      setNextbtn(new_blue2);
    } else {
      $("#next_button").css("background-color", "#efefef");
      $("#dam").css("color", "#b7b7b7");
      setEventcss("disabled-link");
      setNextbtn(nextbtn_new);
    }
  };
  const cashCheck = () => {
    if (cashCount === 0) {
      setCashCount(1);
      setPaymethod("vbank");
      setPaymethod2("T");
      if (cardCount === 1) {
        cardCheck();
      }
      $("#cashtext").css("color", "rgb(74, 100, 245)");
      $("#cash").css("border", "solid 1px #4f63ec");
      $("#cash").css("background-color", "#edefff");
      setCashImg([icon_won_blue]);
    } else {
      setCashCount(0);
      $("#cashtext").css("color", "rgb(81, 81, 81)");
      $("#cash").css("border", "");
      $("#cash").css("background-color", "#ffffff");
      setCashImg([icon_won]);
    }
  };
  let price = "3,300,000원";
  const payment2 = () => {
    ReactPixel.track("InitiateCheckout");
    var IMP = window.IMP;
    IMP.init("imp79162459");
    let merchant_uid1 = "merchant_" + new Date().getTime();
    let coupon = sessionStorage.getItem("coupon");
    var customerclass = "kakao";
    let brandname = "개인결제";
    let firstgoods = "";
    let realprice = price.replaceAll(",", "");
    let realprice2 = realprice.replace("원", "");
    var customeremail = "vkju96@naver.com";
    var customername = "개인";
    var customerPhone = "01042035720";
    let token3 = "asdasdsad";
    let ajaxData =
      "[{'lastgoods':'화장품,세면용품,향수 등 (3류)+ 뷰티 제품명','goods':['직접 브랜딩,제조하시는 화장품이나 세면용품,향수 등  '제품의 이름'을 위한 분류로,해당 '브랜드의 사장님,디자이너님'을 위한 분류입니다.'],'goods2':['화장품,세면용품,향수,화장용 마스크팩,인체용 비누,헤어샴푸,헤어린스, 스킨클렌저,바디및뷰티케어용화장품,선케어제,로션형태의화장품,뷰티로션,치약,향료,립스틱,모발염색제,물티슈,샤워 및 목욕제'],'code':'03','percentage':84.70965870704154},{'lastgoods':'온라인쇼핑몰,스마트스토어 (35류)+의 상호명','goods':['다양한 상품을 온/오프라인으로 판매하시는 '가게이름'을 위한 분류로,'스토어 사장님 및 대표님'들께서 사용하십니다.'],'goods2':[''],'code':'35','percentage':84.70965870704154},{'lastgoods':'공방,학원 등 (41류)+교육 관련 서비스 이름','goods':['00공방,00학원 등 교육과 관련된 '서비스 상호명'을 의미합니다.'사무소장님 및 대표님'들께서 사용하고 계십니다.'],'goods2':['도자기공방지도업, 인터넷교육강좌업, 공예공방지도업, 교육 분야의 연구업, 연기/노래/댄스지도업, 미술 학원체인업, 공예교육업, 시뮬레이터를이용한훈련업, 온라인통신학습업, 온라인훈련제공업, 만화프로그램제작업, 공연기획업, 통신강좌업, 클럽서비스업(연예오락및교육), 인쇄물/서적/잡지/저널/신문/회보/튜토리얼/지도/그래픽/사진/비디오/음악/전자출판물멀티미디어출판업, 음악및엔터테인먼트산업관련교육및훈련업, 개인교수업, 고시 학원업'],'code':'41','percentage':84.70965870704154},{'lastgoods':'인플루언서,크리에이터 (38류)+의 채널이름','goods':['유튜브,인스타그램,블로그 등을 운영하시는'SNS 계정  및 채널 이름'을 위한 분류로,크리에이터 분들께서 사용하십니다.'],'goods2':['동영상 교환 커뮤니티 접속용 통신업,모바일 및 인터넷을 이용한 동영상 전송업,데이터 스트리밍업,디지털 방송업,무선인터넷방송업,인터넷을 이용한 멀티미디어 방송업,온라인 게임 전문 인터넷 방송업,실시간 오디오/비디오/정지 및 동영상 이미지/텍스트/데이터 전송/방송/수신업,영화/음악/비디오/게임 및 멀티미디어 콘텐츠의 스트리밍 서비스제공업,인터넷 및 기타 전자매체상의 전자상거래 플랫폼용 통신서비스제공업,인터넷상의 전자게임 스트리밍업,인터넷상의 포털 접속제공업,방송채널 사용업,인터넷을 이용한 멀티미디어콘텐츠 방송업,텔레비전 콘텐츠 전송업,오디오 및 영상 콘텐츠의 전자 전송/전달업,온라인 영상전송업,멀티미디어콘텐츠 온라인 접속제공업,디지털 미디어 콘텐츠의 스트리밍업'],'code':'38','percentage':84.70965870704154},{'lastgoods':'헤어샵,네일샵 등 뷰티샵 (44류)+의 상호명','goods':['헤어샵,네일샵,피부관리샵 등 뷰티관련 '샵의 이름'을 위한 분류로 '샵 원장님'들께서 사용하십니다.'],'goods2':['네일샵서비스업,미용서비스업,손톱미용업,위생및미용업,인간및동물을위한위생및미용업,인터넷을통한바디및미용관리분야상담업,눈썹관리업,마사지업,머리카락재생에관한개인치료서비스업,메이크업분야상담업,문신서비스업,발관리서비스업,스킨케어서비스업,얼굴관리서비스업,이용업,제모업,페디큐어업,피부미용업,헤어스타일링업'],'code':'44','percentage':84.70965870704154}]";
    let utmRoute = sessionStorage.getItem("utmRoute");
    let goodsSearchWord = ".";
    let searchcategory =
      "화장품/세면용품/향수 등 뷰티 (3류),온라인쇼핑몰/스마트스토어 (35류),공방/학원 등 교육 관련 서비스 (41류),인플루언서/크리에이터 (38류),헤어샵/네일샵 등 뷰티샵 (44류)";
    IMP.request_pay(
      {
        pg: "html5_inicis", // version 1.1.0부터 지원.
        pay_method: paymethod,
        merchant_uid: merchant_uid1,
        name: "상표 출원 신청 :" + brandname,
        amount: realprice2,
        buyer_email: customeremail,
        buyer_name: customername,
        buyer_tel: customerPhone,

        m_redirect_url: "nametec.kr/payment2",
        redirect_url: "nametec.kr/payment2",
      },
      function (rsp) {
        if (rsp.success) {
          var msg = "결제가 완료되었습니다.";
          msg += "고유ID : " + rsp.imp_uid;
          msg += "상점 거래ID : " + rsp.merchant_uid;
          msg += "결제 금액 : " + rsp.paid_amount;
          msg += "카드 승인번호 : " + rsp.apply_num;
          history.push({
            pathname: "/payment2",
            search:
              "?vbank=" +
              paymethod2 +
              "&imp_success=true&imp_uid=" +
              rsp.imp_uid,
          });
        } else {
          var msg = "결제에 실패하였습니다.";
          msg += "에러내용 : " + rsp.error_msg;
        }
      }
    );
  };
  return (
    <>
      <MobileView>
        <div style={{ margin: "auto", maxWidth: "520px" }}>
          <TopbarComponentWithoutPage path={"/Success3"} />

          <div style={{ paddingLeft: "20px" }}>
            <div style={{ width: "342px", margin: "auto" }}>
              <GuidelineComponent3
                title1={"결제하기"}
                help={"결제 수단을 선택해주세요."}
              />
            </div>

            <div
              id="card"
              onClick={cardCheck}
              className="midbox3"
              style={{
                cursor: "pointer",
                paddingLeft: " 16.3px",
                borderColor: "#4a64f5",
              }}
            >
              <img
                loading="lazy"
                id="cardimg"
                src={cardImg[0]}
                style={{ width: "28.9px", marginTop: "13.4px", float: "left" }}
              />
              <div>
                <a
                  id="card_text"
                  className="Regular"
                  style={{
                    fontSize: "14px",
                    color: "#515151",
                    position: "absolute",
                    marginTop: "15.5px",
                    marginLeft: "12.7px",
                  }}
                >
                  신용 / 체크카드
                </a>
              </div>
            </div>

            <div
              id="cash"
              onClick={cashCheck}
              className="midbox23"
              style={{ cursor: "pointer", paddingLeft: "20.8px" }}
            >
              <img
                loading="lazy"
                id="cashimg"
                src={cashImg[0]}
                style={{ width: "20px", marginTop: "13.4px", float: "left" }}
              />
              <div>
                <a
                  id="cashtext"
                  className="Regular"
                  style={{
                    fontSize: "14px",
                    color: "#515151",
                    position: "absolute",
                    marginTop: "15.5px",
                    marginLeft: "17.2px",
                  }}
                >
                  계좌이체
                </a>
              </div>
            </div>
          </div>

          {/*             <button type="button" id="payment_btn" disabled="disabled" style={{cursor : 'pointer',position:'fixed', bottom:'0px',marginTop: '4%',height: '60px', maxWidth : '520px'}}>106,000원 결제하기</button> */}

          <div
            id="next_button"
            className={eventcss}
            onClick={() => payment2()}
            style={{
              cursor: "pointer",
              position: "fixed",
              bottom: "0px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#efefef",
            }}
          >
            <div id="dam" style={{ color: "#b7b7b7" }}>
              {" "}
              {price} 결제하기
            </div>
          </div>
        </div>
      </MobileView>
      <BrowserView>
        <BrowserHeader />

        <div style={{ margin: "0 auto" }}>
          <div style={{ width: "1400px", paddingLeft: "calc(50% - 700px)" }}>
            <img
              loading="lazy"
              src={askalsal}
              style={{
                marginTop: "123px",
                marginLeft: "calc(50% - 602px)",
                width: "515px",
                marginBottom: "50px",
              }}
            />
            <div>
              <div style={{ marginLeft: "454px" }}>
                <img
                  loading="lazy"
                  src={cardImg1[0]}
                  onClick={cardCheck1}
                  style={{
                    marginTop: "23px",
                    marginLeft: "calc(50% - 582px)",
                    width: "372px",
                    marginBottom: "50px",
                  }}
                />
                <img
                  loading="lazy"
                  src={cashImg1[0]}
                  onClick={cashCheck1}
                  style={{
                    marginTop: "23px",
                    width: "372px",
                    marginBottom: "50px",
                  }}
                />
                <div
                  className="Regular1"
                  style={{
                    fontSize: "20px",
                    color: "#515151",
                    marginLeft: "calc(50% - 532px)",
                    lineHeight: "1.5",
                  }}
                >
                  {" "}
                  <a
                    style={{
                      position: "absolute",
                      fontSize: "6px",
                      marginTop: "5px",
                    }}
                  >
                    ●
                  </a>
                  <a style={{ marginLeft: "20px" }}>
                    결제 수단을 선택하시면 KG 이니시스 및 은행 사이트로
                    이동합니다.
                  </a>
                  <br />{" "}
                  <a style={{ marginLeft: "20px", marginTop: "5px" }}>
                    브라우저에 팝업 차단이 되어있다면 반드시 팝업 차단을
                    해제해주세요.
                  </a>
                </div>
                <div
                  className="Regular1"
                  style={{
                    fontSize: "20px",
                    color: "#515151",
                    marginTop: "20px",
                    marginLeft: "calc(50% - 532px)",
                  }}
                >
                  <a
                    style={{
                      position: "absolute",
                      fontSize: "6px",
                      marginTop: "5px",
                    }}
                  >
                    ●
                  </a>{" "}
                  <a style={{ marginLeft: "20px" }}>
                    결제 후, 변리사의 상세 검토를 거쳐 등록이 어렵다고 판단되면
                    전액 환불처리 해드립니다.
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div
            id="introFooter"
            style={{
              float: "right",
              backgroundColor: "#f5f6ff",
              height: "116px",
            }}
          >
            <img
              loading="lazy"
              className={eventcss}
              onClick={() => payment2()}
              src={nextbtn}
              style={{
                cursor: "pointer",
                width: "200px",
                marginLeft: "20px",
                marginTop: "27px",
                float: "right",
                marginRight: "calc(50% - 685px)",
              }}
            />
            <a href="http://pf.kakao.com/_lWuhs/chat">
              <img
                loading="lazy"
                src={kakaoaa}
                onClick=""
                style={{
                  cursor: "pointer",
                  width: "283px ",
                  marginTop: "27px",
                  float: "right",
                }}
              />
            </a>
          </div>
        </div>
      </BrowserView>
    </>
  );
}

export default Personalpayment;
